import { render } from "./Commande.vue?vue&type=template&id=1027fe6b&scoped=true"
import script from "./Commande.vue?vue&type=script&lang=js"
export * from "./Commande.vue?vue&type=script&lang=js"

import "./Commande.vue?vue&type=style&index=0&id=1027fe6b&scoped=true&lang=css"

import exportComponent from "/data/www/cavilam/boutique/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1027fe6b"]])

export default __exports__